export default "__VITE_ASSET__DWgL6dF7__"